import { render, staticRenderFns } from "./MenuGallery.vue?vue&type=template&id=4e509e86&lang=pug&"
import script from "./MenuGallery.vue?vue&type=script&lang=js&"
export * from "./MenuGallery.vue?vue&type=script&lang=js&"
import style0 from "./MenuGallery.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports